import { render, staticRenderFns } from "./CompanyHeaderNav.vue?vue&type=template&id=5512c1bc&"
import script from "./CompanyHeaderNav.vue?vue&type=script&lang=js&"
export * from "./CompanyHeaderNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports